<div class="background-image"></div>
<header class="app__header">
  <!-- <img src="assets/logo.svg" class="app__header-logo" /> -->
  <h2 class="app__header-text">{{title}}</h2>
</header>
